import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['div', 'span']
const ALLOWED_ATTR = ['class']

export function sanitizeHtml(dirty) {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS, ALLOWED_ATTR })
}
